import { createAsyncThunk } from '@reduxjs/toolkit';
import { normalize } from 'normalizr';
import { httpRequest } from '~/adapters/httpRequest';
import { host } from '~/config/settings/worktango.settings';
import { statuses } from '~/config/settings/notification.settings';
import * as languages from '../languages';
import * as transformers from '../transformers';
import * as schemas from '../schemas';

const createCategory = createAsyncThunk(
  'category/createCategory',
  // @ts-expect-error TS(2339): Property 'translations' does not exist on type 'vo... Remove this comment to see the full error message
  async ({ translations, surveyTypeId, isKeyFactor = false, baseCategoryId = null }, { rejectWithValue, getState }) => {
    const state = getState();
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    const languageCodeIds = state.entities.languages.codeIds;
    const names = transformers.categoryTranslationsToNames(translations, languageCodeIds);
    const url = `${host}/categories`;
    const res = await httpRequest(url, {
      method: 'POST',
      body: {
        isKeyFactor,
        names,
        surveyTypeId,
        baseCategoryId,
      },
    });

    if (res.error) return rejectWithValue(res.error);

    const category = transformers.categoryFrom(res?.payload?.category);
    const normalizedData = normalize(category, schemas.category);

    return {
      ...normalizedData,
      surveyTypeId,
      notification: {
        title: languages.t('notifications.title.done'),
        message: languages.t('notifications.message.categoryCreated'),
        status: statuses.success,
      },
    };
  },
);

const updateCategory = createAsyncThunk(
  'category/updateCategory',
  async (
    // @ts-expect-error TS(2339): Property 'categoryId' does not exist on type 'void... Remove this comment to see the full error message
    { categoryId, isKeyFactor, translations = {}, baseCategoryId = null, includeNotification = true },
    { rejectWithValue, getState },
  ) => {
    const state = getState();
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    const languageCodeIds = state.entities.languages.codeIds;
    const names = transformers.categoryTranslationsToNames(translations, languageCodeIds);
    const url = `${host}/categories/${categoryId}`;
    const res = await httpRequest(url, {
      method: 'PATCH',
      body: {
        isKeyFactor,
        names,
        baseCategoryId,
      },
    });

    if (res.error) return rejectWithValue(res.error);

    const category = transformers.categoryFrom(res?.payload?.category);
    const normalizedData = normalize(category, schemas.category);

    const notification = {
      title: languages.t('notifications.title.done'),
      message: languages.t('notifications.message.categoryUpdated'),
      status: statuses.success,
    };

    return {
      ...normalizedData,
      notification: includeNotification ? notification : null,
    };
  },
);

// @ts-expect-error TS(2339): Property 'categoryId' does not exist on type 'void... Remove this comment to see the full error message
const removeCategory = createAsyncThunk('category/removeCategory', async ({ categoryId }, { rejectWithValue }) => {
  const url = `${host}/categories/${categoryId}`;
  const res = await httpRequest(url, {
    method: 'DELETE',
  });

  if (res.error) return rejectWithValue(res.error);

  return {
    id: categoryId,
    notification: {
      title: languages.t('notifications.title.done'),
      message: languages.t('notifications.message.categoryRemoved'),
      status: statuses.success,
    },
  };
});

export const categoryActions = {
  createCategory,
  updateCategory,
  removeCategory,
};
